import React, { useState, useEffect } from 'react';
import { settingsAPI } from '../../services/api';
import { FiSave, FiInfo } from 'react-icons/fi';
import toast from 'react-hot-toast';

// Tahrirlanadigan umumiy sozlamalar
const FIELDS = [
  { key: 'company_name', label: 'Kompaniya nomi', type: 'text', placeholder: 'AUD-IT SOFT MCHJ' },
  { key: 'default_language', label: 'Tizim tili', type: 'select',
    options: [['uz', "O'zbekcha"], ['ru', 'Ruscha'], ['en', 'Inglizcha']] },
  { key: 'max_operators', label: 'Maksimal operatorlar soni', type: 'number', min: 1 },
  { key: 'recording_path', label: 'Yozuvlar papkasi', type: 'text', placeholder: '/var/spool/asterisk/monitor/' },
  { key: 'recording_enabled', label: "Qo'ng'iroqlarni yozib olish", type: 'toggle',
    hint: "Yangi qo'ng'iroqlar yozib olinadimi" },
];

const STATUS_LABELS = { registered: 'Ulangan', unknown: "Noma'lum", failed: 'Xato', unregistered: 'Ulanmagan' };

export default function GeneralSettings() {
  const [form, setForm] = useState({});
  const [raw, setRaw] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await settingsAPI.get();
      const s = res.data.settings || {};
      setRaw(s);
      const f = {};
      FIELDS.forEach(({ key }) => { f[key] = s[key]?.value ?? ''; });
      setForm(f);
      setDirty(false);
    } catch { toast.error('Sozlamalarni yuklashda xato'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const set = (k, v) => { setForm(p => ({ ...p, [k]: v })); setDirty(true); };

  const save = async () => {
    if (form.max_operators !== '' && (isNaN(Number(form.max_operators)) || Number(form.max_operators) < 1)) {
      toast.error("Maksimal operatorlar soni noto'g'ri");
      return;
    }
    setSaving(true);
    try {
      const payload = {};
      FIELDS.forEach(({ key }) => { payload[key] = String(form[key]); });
      await settingsAPI.update(payload);
      toast.success('Sozlamalar saqlandi');
      load();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Saqlashda xato');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  const trunkStatus = raw.sip_trunk_status?.value;

  return (
    <div style={{ maxWidth: 620 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        {FIELDS.map(field => (
          <div key={field.key}>
            <label style={styles.label}>{field.label}</label>

            {field.type === 'text' && (
              <input className="input" value={form[field.key] ?? ''} placeholder={field.placeholder || ''}
                onChange={e => set(field.key, e.target.value)} />
            )}

            {field.type === 'number' && (
              <input className="input" type="number" min={field.min} value={form[field.key] ?? ''}
                onChange={e => set(field.key, e.target.value)} style={{ maxWidth: 200 }} />
            )}

            {field.type === 'select' && (
              <select className="input" value={form[field.key] ?? ''} onChange={e => set(field.key, e.target.value)} style={{ maxWidth: 240 }}>
                {field.options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            )}

            {field.type === 'toggle' && (
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
                <input type="checkbox" checked={String(form[field.key]) === 'true'}
                  onChange={e => set(field.key, e.target.checked ? 'true' : 'false')}
                  style={{ width: 18, height: 18, cursor: 'pointer' }} />
                <span style={{ fontSize: 14, color: 'var(--text-secondary)' }}>
                  {String(form[field.key]) === 'true' ? 'Yoqilgan' : "O'chirilgan"}
                </span>
              </label>
            )}

            {field.hint && <div style={styles.hint}><FiInfo size={12} /> {field.hint}</div>}
          </div>
        ))}

        {/* Read-only: SIP trunk holati */}
        <div>
          <label style={styles.label}>SIP trunk holati</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{
              width: 9, height: 9, borderRadius: '50%',
              background: trunkStatus === 'registered' ? '#10b981' : trunkStatus === 'failed' || trunkStatus === 'unregistered' ? '#ef4444' : '#6b7280',
            }} />
            <span style={{ fontSize: 14, color: 'var(--text-secondary)' }}>
              {STATUS_LABELS[trunkStatus] || trunkStatus || "Noma'lum"}
            </span>
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>(avtomatik aniqlanadi)</span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
          <button className="btn btn-primary" onClick={save} disabled={saving || !dirty}>
            <FiSave size={16} /> {saving ? 'Saqlanmoqda...' : 'Saqlash'}
          </button>
          {dirty && <button className="btn btn-ghost" onClick={load} disabled={saving}>Bekor qilish</button>}
        </div>
      </div>
    </div>
  );
}

const styles = {
  label: { display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 6 },
  hint: { display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: 'var(--text-muted)', marginTop: 5 },
};
